import { FC, useCallback, useEffect, useState } from "react";
import { saveAs } from "file-saver";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { AppDispatch, RootState } from "../../app/store";
import {
  fetchOrders,
  OrderFilters,
  ordersActions,
  OrdersList,
} from "../../modules/orders";
import { exportToCSV } from "../../modules/orders/api";
import { format } from "date-fns";
import styles from "./Orders.module.css";

interface Props {
  siteId: number;
}

export const Orders: FC<Props> = ({ siteId }) => {
  const dispatch = useDispatch<AppDispatch>();
  const [searchParams] = useSearchParams();
  const [isSearchLastChange, setIsSearchLastChange] = useState(false);

  const { status, filters, list, selectedOrdersToProcess } = useSelector(
    (state: RootState) => {
      return state.orders;
    }
  );

  useEffect(() => {
    const start = searchParams.get("start");
    const end = searchParams.get("end");
    const statuses = searchParams.get("statuses") || "";
    dispatch(
      ordersActions.setFilters({
        statuses,
        dates: {
          start: start ? new Date(start) : null,
          end: end ? new Date(end) : null,
        },
      })
    );
  }, [searchParams, dispatch, isSearchLastChange]);

  const getOrders = useCallback(() => {
    dispatch(
      fetchOrders({
        siteId,
        filters,
      })
    );
  }, [siteId, dispatch, filters]);

  useEffect(() => {
    getOrders();
  }, [getOrders]);

  const handleExportOrders = useCallback(async () => {
    const csv = await exportToCSV(siteId, filters);
    const blob = new Blob([csv.data], { type: "text/csv;charset=utf-8" });
    const name = `orders_${format(new Date(), "dd-mm-yyyy_HH:MM")}`;
    saveAs(blob, name);
  }, [siteId, filters]);

  return (
    <div className={styles.container}>
      <div className={styles.filters}>
        <OrderFilters
          filters={filters}
          onSearchLastChanged={setIsSearchLastChange}
        />
      </div>
      <div className={styles.list}>
        <OrdersList
          onExport={handleExportOrders}
          orders={list}
          selectedOrdersToProcess={selectedOrdersToProcess}
          status={status}
          filters={filters}
        />
      </div>
    </div>
  );
};
